import { Component, EventEmitter, Input, Output, OnChanges, HostListener, HostBinding, SimpleChanges, Renderer2, OnInit, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, Inject, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute , Router, NavigationEnd, ResolveEnd, ActivatedRouteSnapshot,
  RouterStateSnapshot, RouterState } from '@angular/router';
import { SafeHtml, SafeResourceUrl, DOCUMENT, DomSanitizer } from '@angular/platform-browser';

import { SymptomDetailsService } from './../services/symptom-details-service';
import { SuggestDiagnosisService } from './../services/suggest-diagnosis.service';

@Component({
  selector: 'app-symptom-trail-details',
  templateUrl: './symptom-details.component.html',
  styleUrls: ['./symptom-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SymptomDetailsComponent implements OnInit, OnChanges, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked {
    private _SymptomDetails = '';
    private _SymptomWithNoDetails: Object;
    loadingResults: boolean;
    articleSearchCompleted: boolean;
    renderer2: Renderer2;
    @Output() onClickArticleDetails = new EventEmitter<String>();
    @Output() onCancelSymptomDetails = new EventEmitter<String>();

    // @Input() whereToQueryParams: any;
    @Input()
    set SymptomDetails(SymptomDetails: any){
        if (typeof SymptomDetails === 'object') {
          this.loadingResults = false;
          this._SymptomDetails = SymptomDetails;
          this._SymptomWithNoDetails = undefined;
        }else {
          this.loadingResults = false;
          this._SymptomDetails = undefined;
          this._SymptomWithNoDetails = {
            'SymptomName' : SymptomDetails,
            'MayoClinc': 'http://www.mayoclinic.org/search/search-results?q=' + SymptomDetails,
            'MedlinePlus': 'http://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?v%3Aproject=medlineplus&query=' + SymptomDetails,
            'WebMD': 'http://www.webmd.com/search/search_results/default.aspx?query=' + SymptomDetails
          };
        }
    }
    get SymptomDetails(): any{
      return this._SymptomDetails;
    }
    get SymptomWithNoDetails(): any{
      return this._SymptomWithNoDetails;
    }

    constructor(
        private ActRoute: ActivatedRoute,
        private router: Router,
        private SymptomDetailsService: SymptomDetailsService,
        private SuggestDiagnosisService: SuggestDiagnosisService,
        private sanitizer: DomSanitizer,
        el: ElementRef,
        @Inject(DOCUMENT) private document: any,
        renderer: Renderer2
      ) {
        this.renderer2 = renderer;
        this.loadingResults = true;
      }

    ngOnInit() {
      this.articleSearchCompleted = false;
    }

    ngOnChanges(changes: SimpleChanges) {
      setTimeout(() => {
        // console.log('ngAfterViewInit timeout');
        // console.log(this.document.querySelectorAll('.articleSearchClick'));
          const articleIdNodeList = this.document.querySelectorAll('.articleSearchClick');
          const articleIdArrayList = Array.from(articleIdNodeList);
          if (articleIdArrayList) {
            articleIdArrayList.forEach((item: HTMLAnchorElement) => {
              if (item !== undefined) {
                this.renderer2.listen(item, 'click', (event) => {
                  this.articleSearchCompleted = true;
                  event.preventDefault();
                  this.onArticleDetails(item.id, event.target.innerText);
                });
              }
            });
          }
       }, 1000);
    }

    public onArticleDetails(chunkID: String, articleName): void {
        this.onClickArticleDetails.emit(chunkID);
        this.SuggestDiagnosisService.onTriggerTrackingEvent('ARTICLE DETAILS', articleName);
    }

    public onCancelDetails(): void {
      this.onCancelSymptomDetails.emit();
      this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS', null);
    }

    public onClickhref(noDetailsUrl: any): void {
      window.top.location.href = noDetailsUrl;
      // window.top.history.pushState(null, null, 'https://internetdevbcbsal.bcbsal.org/web/symptom-checker#_48_INSTANCE_lc9Vbj4LeWKH_%3Dhttps%253A%252F%252Finternetdevbcbsal.bcbsal.org%252Fcontent_2015%252Fisabel%252Findex.html%2523%252Fsuggest-diagnosis/3/f/12/0/fever');
    }

    // public onWhereNow(): void {
    //   console.log(this.whereToQueryParams);
    //   if (this.whereToQueryParams !== undefined) {
    //     this.router.navigate(['/where-to-go-tool'], { queryParams: this.whereToQueryParams });
    //   }
    // }


    ngAfterContentInit() {
      // console.log('ngAfterContentInit');
    }
    ngAfterContentChecked() {
      // console.log('ngAfterContentChecked');
    }
    ngAfterViewInit() {
      // console.log('ngAfterViewInit');
    }
    ngAfterViewChecked() {
      //  console.log('ngAfterViewInit');
    }
}



// WEBPACK FOOTER //
// ./src/app/symptom-details/symptom-details.component.ts